/**
 * Module dependencies.
 */

import { AnimationController } from 'src/components/core/animations/animation-controller';
import { CardMovelUnit } from 'src/components/core/cards/card-movel-unit';
import { FadeInUp } from 'src/components/core/animations/fade-in-up';
import { Grid, SubGrid } from 'src/components/core/layout/grid-content';
import { Section } from 'src/components/core/layout/section';
import styled from 'styled-components';

/**
 * `StyledCardMovelUnit` styled component.
 */

const StyledCardMovelUnit = styled(CardMovelUnit)`
  height: 100%;
  padding-top: 0;
`;

/*
 * Export `ContactCard` component.
 */

export const ContactCard = () => {
  return (
    <AnimationController>
      <Section style={{ overflow: 'hidden' }}>
        <Grid data-has-offset-gutter>
          <SubGrid style={{ minWidth: 0 }}>
            <FadeInUp style={{ height: 'fit-content' }} triggerInView>
              <StyledCardMovelUnit />
            </FadeInUp>
          </SubGrid>
        </Grid>
      </Section>
    </AnimationController>
  );
};
